import * as yup from "yup";
// import { extractUnits } from "../../../helpers/converters/units";

const getValidation = () => {
  return yup.object({
    frequencyFrom: yup.string()
      .required('Required')
      .matches(/^\d*\.?\d+ +(nHz|Hz|MHz|GHz|kHz|µHz|THz)$/, 'Invalid value'),
    stepFrequencyWidth: yup.string()
      .required('Required')
      .matches(/^\d*\.?\d+ +(nHz|Hz|MHz|GHz|kHz|µHz|THz)$/, 'Invalid value'),
    stepCount: yup.number()
      .typeError('Should be a number')
      .required('Required')
      .min(2, 'Min value is 2')
      .max(36, 'Max value is 36')
      .integer('Should be a whole number'),
    maxNumberOfDevicesAllowed: yup.number()
      .typeError('Should be a number')
      .min(1, 'Should be a positive number')
      .integer('Should be a whole number')
  });
}

export default getValidation;